/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BonusFuelOption = {
    FLAT_AMOUNT: 'FLAT_AMOUNT',
    MULTIPLE_AMOUNT: 'MULTIPLE_AMOUNT'
} as const;
export type BonusFuelOption = typeof BonusFuelOption[keyof typeof BonusFuelOption];


export function instanceOfBonusFuelOption(value: any): boolean {
    for (const key in BonusFuelOption) {
        if (Object.prototype.hasOwnProperty.call(BonusFuelOption, key)) {
            if (BonusFuelOption[key as keyof typeof BonusFuelOption] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BonusFuelOptionFromJSON(json: any): BonusFuelOption {
    return BonusFuelOptionFromJSONTyped(json, false);
}

export function BonusFuelOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusFuelOption {
    return json as BonusFuelOption;
}

export function BonusFuelOptionToJSON(value?: BonusFuelOption | null): any {
    return value as any;
}

export function BonusFuelOptionToJSONTyped(value: any, ignoreDiscriminator: boolean): BonusFuelOption {
    return value as BonusFuelOption;
}

